/* eslint-disable i18next/no-literal-string */

import { type UserProfileDataType } from '@aikoa/common'
import { useMutation } from '@tanstack/react-query'
import { verifyOrCreateUserProfile } from '~/data/user/writeUserProfile'
import { supabase } from '~/lib/supabase'
import { queryClient } from '~/lib/trpc'

export function useSetupBuyerAccount() {
  return useMutation({
    mutationFn: async ({ profileData }: { profileData?: UserProfileDataType }) => {
      const { data: userData, error: userError } = await supabase.auth.getUser()
      const user = userData?.user

      if (userError || !user) {
        throw userError || new Error('No authenticated user')
      }

      const currentProfile = await verifyOrCreateUserProfile({
        user,
        createRole: 'buyer',
        profileData,
      })

      if (!currentProfile) {
        throw new Error('Failed to create buyer profile')
      }

      return true
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['userProfile'],
      })

      return true
    },
    onError: (error) => {
      console.error(error)
      return false
    },
  })
}
